// extracted by mini-css-extract-plugin
export default {"image":"ModalSection_image__q0Feo"};